import React from 'react';
import { RenderModule } from 'holocron';
import clsx from 'clsx';
import { ProgressCircular } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { usePersonaExploreMore } from '../../hooks/usePersonaApi';
import { PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME } from '../../constants/modules';
import style from './ExploreMore.scss';

export const ExploreMore = () => {
  const {
    heading,
    articles,
    personaType,
    isLoading: personaLoading,
  } = usePersonaExploreMore();
  const locale = useSelector(getActiveLocaleSelector);

  if (personaLoading) {
    return (
      <div className={clsx('container flex flex-justify-center flex-align-center', style.loaderContainer)}>
        <ProgressCircular size="lg" />
      </div>
    );
  }

  if (articles.length === 0) {
    return null;
  }

  const [, market] = locale.toLowerCase().split('-');
  const analyticsElementPrefix = `${market}hp-explore-more-${personaType}`;

  return (
    <div data-testid="axp-travel-home-explore-more" className="pad-4-b pad-4-t pad-t-xs-down">
      <RenderModule
        moduleName={PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME}
        props={{
          heading,
          articles,
          analyticsElementPrefix,
        }}
      />
    </div>
  );
};

export default ExploreMore;
